// components/Molecules/Meta/Meta.js
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Meta - Key-value metadata display
 * 
 * Displays structured metadata as key-value pairs.
 * Keys are bold, values are normal weight, all small text.
 * 
 * Usage:
 *   <Meta items={[
 *     { key: 'Type', value: 'Interactive App' },
 *     { key: 'Status', value: 'Released' },
 *     { key: 'Technologies', value: 'React, Wagtail' }
 *   ]} />
 */
const Meta = ({ items = [], className = '' }) => {
  if (!items || items.length === 0) return null;
  
  return (
    <div className={`cluster cluster-normal ${className}`}>
      {items.map((item, index) => (
        <div key={index} className="text-sm">
          <span className="font-semibold text-neutral-700">{item.key}:</span>{' '}
          <span className="text-neutral-600">{item.value}</span>
        </div>
      ))}
    </div>
  );
};

Meta.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  className: PropTypes.string,
};

export default Meta;